import React, { useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import Layout from "../components/Layout";
import { Mail, ArrowLeft } from "lucide-react";

export default function GlemtPassord() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim() });
      setSubmitted(true);
    } catch {
      // Vi viser samme melding uansett (forhindrer enumeration)
      setSubmitted(true);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Layout>
      <div className="max-w-md mx-auto pt-12" data-testid="forgot-password-page">
        <Link to="/?tab=login" className="font-meta text-[10px] tracking-[0.2em] text-[var(--cream-soft)] hover:text-[var(--magenta)] flex items-center gap-1 mb-6">
          <ArrowLeft className="h-3 w-3" /> TILBAKE TIL INNLOGGING
        </Link>

        <div className="font-meta text-[10px] tracking-[0.3em] text-[var(--magenta)] mb-2 flex items-center gap-2">
          <Mail className="h-3 w-3" /> GJENOPPRETT TILGANG
        </div>
        <h1 className="font-fraunces italic text-4xl text-[var(--cream)] mb-3">Glemt passord</h1>
        <p className="text-sm text-[var(--cream-soft)] mb-8 leading-relaxed">
          Skriv inn e-postadressen din. Vi sender deg en lenke til å velge nytt passord.
        </p>

        {submitted ? (
          <div className="panel p-6 text-sm text-[var(--cream)] leading-relaxed" data-testid="forgot-success">
            Hvis kontoen finnes har vi sendt en lenke til <strong>{email}</strong>.
            <br /><br />
            <span className="text-[var(--cream-soft)]">
              Sjekk innboksen din (og spam-mappen). Lenken er gyldig i 60 minutter.
            </span>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="din@email.no"
              className="input-editorial w-full"
              data-testid="forgot-email-input"
            />
            <button type="submit" disabled={busy} className="btn-magenta w-full" data-testid="forgot-submit">
              {busy ? "Sender…" : "Send lenke"}
            </button>
          </form>
        )}
      </div>
    </Layout>
  );
}
